<template>
  <div class="ui toggle checkbox" @click="setValue(!getValue)">
    <input type="checkbox"  :checked="getValue" :readonly="property.readonly">
    <label >{{!options.hideLabel?label:''}}</label>
  </div>
</template>

<script>
    import singleControlMixin from './singleControlMixin'
    export default {
      name:"checkbox-control",
      mixins: [singleControlMixin],
    }
</script>

<style scoped>

</style>
